import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BryxTypography from "../components/BryxTypography";
import BryxBox from "../components/BryxBox";
import BryxColors from "../types/theme";
const withLabel = (WrappedComponent) => {
    return (props) => {
        const { label, error, disabled, sx, ...componentProps } = props;
        const isLabelDefined = label !== undefined;
        const labelHasText = typeof label === "string";
        const shouldHaveSpacing = isLabelDefined && !labelHasText;
        const labelCSS = {
            ...(error && {
                color: BryxColors.lightNotify("error"),
            }),
        };
        const containerProps = {
            isFlex: true,
            fullWidth: true,
            column: true,
            ...(isLabelDefined && {
                xsGap: true,
            }),
            hoverable: !error && !disabled,
        };
        return (_jsxs(BryxBox, { ...containerProps, children: [_jsx(BryxBox, { isFlex: true, sx: { height: shouldHaveSpacing ? "18px" : "initial" }, children: _jsx(BryxTypography, { variant: "body1", sx: { ...labelCSS }, children: label }) }), _jsx(BryxBox, { isFlex: true, children: _jsx(WrappedComponent, { ...componentProps, ...(error && { error }), ...(disabled && { disabled }), sx: { ...sx } }) })] }));
    };
};
export default withLabel;
